const footer = {
    location: 'באר שבע, ישראל',
    myName: 'תומר הללי',
    navigate: 'ניווט',
    reach: 'ליצירת קשר',
    elsewhere: 'ברשתות',
    builtWith: 'React · TypeScript · SCSS',
};

export default footer;
